import UserVerificationRoute from './UserVerificationRoute';

export default UserVerificationRoute;
